import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import PasswordInput from '../../components/PasswordInput.vue'

export default {
  name: 'Profile',
  computed,
  data,
  methods,
  mounted,
  components: {
    PasswordInput,
  },
}
